<span class="pcp-message" *ngIf="showPcpMessage">
  <app-disclaimers
    [disclaimers]="pcpDisclaimers"
    [container]="true"
    (click)="handleOnClick($event)"
  ></app-disclaimers>
</span>
